/*
 *
 *  actions
 *
 */

import {
 
  LOAD_RECORDS,
  LOAD_RECORDS_SUCCESS,
  LOAD_RECORDS_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
 
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

/**
 * @param {boolean} invalidateCache
 */
export function loadRecords(searchFilter) {
  return {
    type: LOAD_RECORDS,
    searchFilter,
  }
}

/**
 * @param {array} records
 */
export function loadRecordsSuccess(shooter_available_list, success) {
  return {
    type: LOAD_RECORDS_SUCCESS,
    shooter_available_list,
    success,
  }
}

/**
 * @param {string} error
 */
export function loadRecordsError(error) {
  return {
    type: LOAD_RECORDS_ERROR,
    error,
  }
}





export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}



const actions = {
  loadRecords,
  loadRecordsSuccess,
  loadRecordsError,

  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

}

export default actions
